<template>
    <div>
      <div class='titlelist' style="white-space: nowrap;">
        <div v-for='(v,i) in params' :key='i+"101"' @click='handclick(i)' :style="{borderRight:(i+1)<params.length?'1px solid #d8d8d8':'',padding: islang == 'eng'?'0 1rem':'0 1.8rem'}">
        <span :style="{borderBottom:isright==i?'3px solid #09666E':'',color:isright==i?'#09666E':''}">{{v.text}}</span>
        </div>
      </div>
    </div>
</template>

<script>
  export default{
    props:['isnum'],
    data(){
      return{
        islang : window.localStorage.guanwanglang,
        params:[],
        urllist:['/privacy_policy','/risk_disclosure_statement','/terms_&_conditions_of_use','/hyperlink_policy','/security_usage_tips','/privacy_data_policy'],
        isright:0
      }
    },
    watch:{
      isnum:{
        immediate:true,
        handler(ev){
          this.isright = this.isnum || 0
        }
      }
    },
    mounted() {
      document.documentElement.scrollTop = 0;
      // javascript:window.history.forward(1);
      this.getdate()
    },
    methods:{
      getdate() {
        this.$ajax({
          method: 'post',
          url: this.$api.getGroupMenu,
        }).then(res => {
          let arr = res.data.groupMenuList.reverse();
          for(let a = 0;a<5;a++){
            this.params.unshift(arr[a])
          }
          let arrs = {
            text:this.$lang.grsm,
            url:'/privacy_data_policy',
          }
          this.params.push(arrs)
        })
      },
      handclick(i){
        this.isright = i
        if(this.urllist[i]){
          this.$router.push(this.urllist[i])
        }
      },
    }
  }
</script>
<style>
  .look_g{
    position: relative !important;
    left: -14.4px !important;
  }
</style>
<style scoped>
  .titlelist{
    /* display: flex;
    justify-content: space-between; */
    text-align: center;
    font-size: 16px;
    margin-bottom: 1.5rem;
    margin-left: -1rem;
  }
  .titlelist div{
    display: inline-block;
    font-size: 18px;
    color: #000;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/safenotice&advice/titlelist.vue